import React, { createContext } from 'react';
import { useLocalStorage } from '../hooks/LocalStarageHook';

export const ThemeContext = createContext();

const ThemeContextProvider = (props) => {
  //const [dark, setDark] = useState(false);
  const [dark, setDark] = useLocalStorage('darkTheme', false);

  return (
    <ThemeContext.Provider value={{dark, setDark}}>
      {props.children}
    </ThemeContext.Provider>
  );
}

export default ThemeContextProvider;